import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgAdd = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M12 18a1 1 0 0 0 1-1v-4h4a1 1 0 1 0 0-2h-4V7a1 1 0 1 0-2 0v4H7a1 1 0 1 0 0 2h4v4a1 1 0 0 0 1 1Z" />
  )
export default SvgAdd
